import { render } from "./InterstitialFive.vue?vue&type=template&id=684673e6&scoped=true"
import script from "./InterstitialFive.vue?vue&type=script&lang=js"
export * from "./InterstitialFive.vue?vue&type=script&lang=js"

import "./InterstitialFive.vue?vue&type=style&index=0&id=684673e6&lang=scss&scoped=true"

import exportComponent from "/Users/danny/Documents/projects/camden-mobile/microsite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684673e6"]])

export default __exports__